var EqVersionInfo = /** @class */ (function () {
    function EqVersionInfo(major, minor, update) {
        this.major = major;
        this.minor = minor;
        this.update = update;
    }
    EqVersionInfo.prototype.toString = function () {
        return this.major + "." + this.minor + "." + this.update;
    };
    return EqVersionInfo;
}());
export var versionInfo = new EqVersionInfo(6, 2, 0);
//# sourceMappingURL=version_info.js.map